

























































import { Component, Vue } from 'vue-property-decorator'
import { TableColumnItemType, OperationItemType, OptionItemType } from '../../../types/type'
import { Pagination } from '../../../mixins/pagination'
import { UserModule, CommonModule } from '../../../store'
import { findItemForTree, getNameTextInOptions } from '../../../utils/toolsForCommon'
import { encode } from 'js-base64'
import { columnForCapitalShiftTo } from '@/utils/columnForTable'
@Component({
  name: 'CapitalShiftToHistoryForSchool',
  mixins: [Pagination],
  components: {
    'concise-card-have-title-acquiescent': () => import('../../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'table-module': () => import('../../../components/common/tableModule.vue')
  }
})
export default class CapitalShiftToHistoryForSchool extends Vue {
  public loading = false
  // 列表列有哪些：
  public tableColumnList: Array<TableColumnItemType> = [
    ...columnForCapitalShiftTo,
    // {
    //   title: '操作人',
    //   key: 'updatedBy',
    //   type: 'text',
    //   showStateForTableHeader: 'unilaminar',
    //   width: '200px'
    // }
    {
      title: '审批人',
      key: 'auditors',
      type: 'listForTitleValueShow',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    }
  ]
  // 列表每一行的操作有哪些：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '详情',
      key: 'detail',
      type: 'primary',
      size: 'mini'
    },
    // {
    //   title: '取消',
    //   key: 'cancelForCapitalShiftToHistoryOfSchool',
    //   type: 'danger',
    //   size: 'mini'
    // },
    {
      title: '确认',
      key: 'confirmForCapitalShiftToHistoryOfSchool',
      type: 'success',
      size: 'mini'
    },
    {
      title: '收据单',
      key: 'receiptForCapitalShiftToHistoryOfSchool',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '审批记录(有驳回)',
      key: 'failForCapitalShiftToHistoryOfSchool',
      type: 'danger',
      size: 'mini'
    },
    {
      title: '撤回审批(即取消)',
      key: 'withdrawForCapitalShiftToHistoryOfSchool',
      type: 'danger',
      size: 'mini'
    },
    {
      title: '修改登记表',
      key: 'updateForCapitalShiftToHistoryOfSchool',
      type: 'primary',
      size: 'mini'
    }
    // 学校端暂时不开通此功能：
    // {
    //   title: '删除',
    //   key: 'deleteForCapitalShiftToHistoryOfSchool',
    //   type: 'danger',
    //   size: 'mini'
    // }
  ]
  // 列头操作：
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-bottom'></span>导出资金转出记录",
      key: 'exportExcel',
      type: 'primary',
      size: '',
      canExportOutFlag: true,
      titleCopy: "<span class='el-icon-bottom'></span>导出资金转出记录",
      exportResultFileName: '资金转出记录列表.xlsx',
      exportLoading: "<span class='el-icon-loading'></span>正在导出中，请稍后",
      exportError: '抱歉，导出失败',
      exportSuccess: '导出成功'
    },
    {
      title: "<span class='el-icon-caret-left m_r5'></span>返回",
      key: 'back',
      type: 'primary',
      size: ''
    }
  ]
  // 枚举选项：
  // 资金转出记录：
  public optionsForAuditStatus: Array<OptionItemType> = [
    {
      name: '已取消',
      value: -1
    },
    {
      name: '审核岗待审批',
      value: 0
    },
    {
      name: '拨付岗待审批',
      value: 4
    },
    {
      name: '学校待确认',
      value: 1
    },
    {
      name: '已驳回',
      value: 2
    },
    {
      name: '已确认',
      value: 3
    }
  ]
  public optionsForAuditStatusForTagType: Array<OptionItemType> = [
    {
      name: 'danger',
      value: -1
    },
    {
      name: '',
      value: 0
    },
    {
      name: '',
      value: 4
    },
    {
      name: 'success',
      value: 1
    },
    {
      name: 'danger',
      value: 2
    },
    {
      name: 'success',
      value: 3
    }
  ]
  // 查看驳回详情：
  public visibleForFailReasonDetailList: boolean = false
  public failReasonDetailList: Array<any> = []
  public loadingForFailReasonDetailList: boolean = false
  // 20220922新增 列自定义选择展示：
  public checkedListForTableColumnList: Array<string> = []

  get userInfo () {
    return UserModule.userInfo
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  mounted () {
    CommonModule.getTreeDataForOrganization()
    this.getTableDataList()
    this.checkedListForTableColumnList = [...this.tableColumnList.slice(0).map(item => item.key)]
  }

  // 操作按钮：
  operationForButton ({ key }, row, uploadFile?: File) {
    switch (key) {
      case 'detail':
        const detail = encode(JSON.stringify(row))
        this.$router.push({ name: 'CapitalShiftToHistoryDetail', query: { detail, source: 'school' } })
        break
      case 'cancelForCapitalShiftToHistoryOfSchool':
        this.operationForTheCapitalShiftToHistory([row.id], 0, '确定要取消此资金转出记录吗？')
        break
      case 'confirmForCapitalShiftToHistoryOfSchool':
        this.operationForTheCapitalShiftToHistory([row.id], 1, '要确定此资金转出记录吗？')
        break
      case 'receiptForCapitalShiftToHistoryOfSchool':
        // targetId: 对应的业务id，type为1时为资金转入记录id；type为2时为资金拨付申请id
        // type: 收据类型：1：资金转入；2：资金拨付
        this.$router.push({ name: 'CapitalReceiptDetail', query: { targetId: row.id, type: '1', source: 'school' } })
        break
      case 'failForCapitalShiftToHistoryOfSchool':
        this.visibleForFailReasonDetailList = true
        this.getFailReasonDetail(row.id)
        break
      case 'withdrawForCapitalShiftToHistoryOfSchool':
        this.operationForTheCapitalShiftToHistory([row.id], 0, '确定要撤回此资金转出记录吗？')
        break
      case 'updateForCapitalShiftToHistoryOfSchool':
        const detailForUpdateForCapitalShiftToHistoryOfSchool = encode(JSON.stringify(row))
        this.$router.push({ name: 'CapitalShiftToAffirm', query: { detail: detailForUpdateForCapitalShiftToHistoryOfSchool, id: row.id } })
        break
      case 'deleteForCapitalShiftToHistoryOfSchool':
        const { id } = row
        this.operationForDelete([id], '确定要删除此资金转出记录吗？')
        break
      case 'exportExcel':
        // 开始导出：纯前端导出
        this.operationForButtonOfTableHeader.forEach(async item => {
          if (item.key === 'exportExcel') {
            if (!item.canExportOutFlag) return this.$message.error('请等待上一次请求完成！')
            item.canExportOutFlag = false
            item.title = item.exportLoading
            // start:
            const keysList = this.tableColumnList.map(v => v.key)
            const dataRes = ((this as any).tableDataList || []).map(v => {
              return keysList.map(vv => {
                let res = ''
                switch (vv) {
                  case 'town':
                  case 'school':
                    const NodeRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', v[vv])
                    if (!Object.keys(NodeRes).length) {
                      res = '- -'
                    } else {
                      res = NodeRes['name']
                    }
                    break
                  default:
                    res = v[vv]
                }
                return res
              })
            })
            import('../../../plugins/xlsx/exportExcel').then(excel => {
              let tHeader = this.tableColumnList.map(v => v.title)
              try {
                excel.export_json_to_excel({
                  multiHeader2: [], // 这里是第一行的表头
                  multiHeader: [], // 这里是第二行的表头
                  header: tHeader, // 这里应该是算第三行的表头
                  data: dataRes,
                  merges: [],
                  filename: item.exportResultFileName
                })
                this.$message.success(item.exportSuccess)
                item.canExportOutFlag = true
                item.title = item.titleCopy
              } catch (err) {
                this.$message.error(item.exportError)
                item.canExportOutFlag = true
                item.title = item.titleCopy
              }
            })
            // end
          }
        })
        break
      case 'back':
        // this.$router.push({ name: 'CapitalApplicationForUse' })
        this.$router.go(-1)
        break
    }
  }

  operationForTheCapitalShiftToHistory (ids: Array<string | number>, operation: number, confirmText: string) {
    let messageText = ''
    // 0表示取消，1表示确认
    switch (operation) {
      case 0:
        messageText = '操作成功，已取消'
        break
      case 1:
        messageText = '操作成功，已确认'
        break
    }
    this.$confirm(confirmText, '提示', {
      confirmButtonText: `确定`,
      cancelButtonText: `取消`,
      type: 'warning'
    }).then(async () => {
      let { data: result } = await (this as any).$http.capitalTransferApprove({
        ids,
        audit: operation ? true : false,
        role: 'SCHOOL'
      })
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(messageText)
      this.getTableDataList()
    }).catch(() => {})
  }

  async getFailReasonDetail (id) {
    try {
      this.failReasonDetailList = []
      this.loadingForFailReasonDetailList = true
      const params = {
        auditScene: 2, // 1:会计凭证审核;2:资金转账记录;3:资金使用申请
        id
      }
      const { data: result } = await (this as any).$http.getLogAudit(params)
      this.loadingForFailReasonDetailList = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.failReasonDetailList = (result.data || []).map(item => {
        let res = ''
        const NodeRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', item['operatorOrg'])
        if (!Object.keys(NodeRes).length) {
          res = '- -'
        } else {
          res = NodeRes['name']
        }
        item.description = `
          ${item.audit ? '通过' : '驳回'}
          ----
          ${res}
          组织节点的用户（
          ${item['operatorName']}
          ）在
          ${item['time']}
          进行处理，处理完的状态为：
          ${getNameTextInOptions(this.optionsForAuditStatus, item['resultStatus'])}
          ，处理原因为：
          ${item['reason'] ? item['reason'] : '- -'}
        `
        return item
      })
    } catch (err) {
      console.log(err)
    }
  }

  async getTableDataList () {
    try {
      const _that: any = this
      this.loading = true
      const params = {
        schoolId: this.userInfo.organizationId
      }
      const { data: result } = await (this as any).$http.capitalInfoTransferInfo(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      _that.tableDataList = (result.data || []).map(item => {
        item['tagType'] = getNameTextInOptions(this.optionsForAuditStatusForTagType, item.status)
        item.status = getNameTextInOptions(this.optionsForAuditStatus, item.status)
        item.time = item.time.split(' ')[0]
        return item
      })
    } catch (err) {
      console.log(err)
    }
  }

  // 删除：
  operationForDelete (ids: Array<string | number>, confirmText: string) {
    this.$confirm(confirmText, '提示', {
      confirmButtonText: '确定删除',
      cancelButtonText: '取消删除',
      type: 'error'
    }).then(async () => {
      let { data: result } = await (this as any).$http.capitalTransferDel({ ids: ids.join(',') })
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('删除成功！')
      this.getTableDataList()
    }).catch(() => {})
  }
}
